export default __webpack_public_path__ + "static/media/noredine.66448dd1.png";